import { render, staticRenderFns } from "./NewsLayers.vue?vue&type=template&id=865bd278&"
import script from "./NewsLayers.vue?vue&type=script&lang=js&"
export * from "./NewsLayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports